module.exports = __webpack_public_path__ + "img/u64.3fcad47a.png";